import useSWR from 'swr'

import { getApiVersionDygc, getApiVersion, http } from '../utils/domain'

const useCustomInfoSWR = (key) => {
  const { data, mutate, error } = useSWR(`?key=${key}`, {
    fetcher: () => {
      if (key === 'xc') {
        return Promise.resolve({
          data: {
            allowLoginType: ['tel', 'code'],
            // 登录页面上可能会展示一下企业相关信息
            prefix: 'screen',
            theme: 'dp',
            title: '西城',
            welcome: '',
            introduction: '西城',
            logo: null, // logo
            image: null,
            bgImage: null,
            // 登录相关
            loginTitle: '登录title',
            loginIntroduction: '登录Introduction',
            url: {
              navType: 'push',
              url: '/workbench?token=$token',
              project: 'nest',
            },
          },
        })
      }
      if (key === 'wz') {
        return Promise.resolve({
          data: {
            allowLoginType: ['tel', 'code'],
            // 登录页面上可能会展示一下企业相关信息
            prefix: 'common',
            theme: 'common',
            title: '无证无照经营整治第三方核查项目',
            welcome: '',
            introduction: '无证无照经营整治第三方核查项目',
            logo: null, // logo
            image: null,
            bgImage: null,
            // 登录相关
            loginTitle: '登录',
            loginIntroduction: '登录',
            url: {
              navType: 'push',
              url: '/cp/tsy-wz/apps/970/tbs/520?vid=1510&tpl=wz&token=$token',
              project: 'tsy-wz',
            },
          },
        })
      }

      if (key === 'zt') {
        return Promise.resolve({
          data: {
            allowLoginType: ['tel', 'code'],
            prefix: 'common',
            theme: 'common',
            // 登录页面上可能会展示一下企业相关信息
            title: '西城管委渣土管理和执法预约平台',
            welcome: '',
            introduction: '',
            logo: null, // logo
            image: null,
            bgImage: null,
            // 登录相关
            loginTitle: '西城管委渣土管理和执法预约平台',
            loginIntroduction: '西城管委渣土管理和执法预约平台',
            url: {
              navType: 'push',
              url: '/workbench?key=zt',
              project: 'web',
            },
          },
        })
      }
      // 刘晓平项目
      if (key === 'ugm') {
        return Promise.resolve({
          data: {
            allowLoginType: ['tel'],
            prefix: 'common',
            theme: 'common',
            title: '垃圾分类示范片区复验和部分示范片区二次验收服务',
            welcome: '',
            introduction: '垃圾分类示范片区复验和部分示范片区二次验收服务',
            logo: null, // logo
            image: null,
            bgImage: null,
            // 登录相关
            loginTitle: '垃圾分类示范片区复验和部分示范片区二次验收服务',
            loginIntroduction: '垃圾分类示范片区复验和部分示范片区二次验收服务',
            navTitle: '垃圾分类示范片区复验和部分示范片区二次验收服务',
            url: {
              navType: 'push',
              url: '/apps/957/tbs/527?vid=1405&token=$token&tpl=ugm',
              project: 'web',
            },
          },
        })
      }
      // 西城管委王梓-联合执法预约
      if (key === 'lhzf') {
        return Promise.resolve({
          data: {
            allowLoginType: ['tel', 'code'],
            prefix: 'common',
            theme: 'common',
            title: '西城区建筑垃圾协同管理执法系统',
            welcome: '',
            introduction: '西城区建筑垃圾协同管理执法系统',
            logo: null, // logo
            image: null,
            bgImage: null,
            // 登录相关
            loginTitle: '西城区建筑垃圾协同管理执法系统',
            loginIntroduction: '西城区建筑垃圾协同管理执法系统',
            url: {
              navType: 'push',
              url: '/cp/xc-lhzf/workbench?key=zt',
              project: 'xc-lhzf',
            },
          },
        })
      }
      if (key === 'jzlj') {
        return Promise.resolve({
          data: {
            allowLoginType: ['tel', 'code'],
            prefix: 'common',
            theme: 'common',
            title: '西城区建筑垃圾协同管理执法系统',
            welcome: '',
            introduction: '西城区建筑垃圾协同管理执法系统',
            logo: null, // logo
            image: null,
            bgImage: null,
            // 登录相关
            loginTitle: '西城区建筑垃圾协同管理执法系统',
            loginIntroduction: '西城区建筑垃圾协同管理执法系统',
          },
        })
      }
      if (key === 'yyzcjc') {
        return Promise.resolve({
          data: {
            allowLoginType: ['tel', 'code'],
            prefix: 'common',
            theme: 'common',
            title: '政策监测及政策数据库搭建项目',
            welcome: '',
            introduction: '政策监测及政策数据库搭建项目',
            logo: null, // logo
            image: null,
            bgImage: null,
            // 登录相关
            loginTitle: '政策监测及政策数据库搭建项目',
            loginIntroduction: '政策监测及政策数据库搭建项目',
            url: {
              navType: 'push',
              url: '/apps/973/pages/yy?tpl=yyzcjc&vid=1407&token=$token',
              project: 'web',
            },
          },
        })
      }
      if (key === 'zrzh') {
        return Promise.resolve({
          data: {
            allowLoginType: ['tel'],
            prefix: 'zrzh',
            theme: 'common',
            title: '第一次自然灾害普查县级应用系统',
            welcome: '',
            introduction: '第一次自然灾害普查县级应用系统',
            logo: null, // logo
            image: null,
            bgImage: null,
            // 登录相关
            loginTitle: '第一次自然灾害普查县级应用系统',
            loginIntroduction: '第一次自然灾害普查县级应用系统',
            // 导航相关
            navTitle: '第一次自然灾害普查县级应用系统',
            navIcon: {
              icon: 'zrzhIcon',
            },
            url: {
              navType: 'push',
              url: '/cp/nmgmtyq-zrzh/apps/974/tbs/567?vid=1421&tpl=zrzh&token=$token&treeKey=zrzhczt_ggfwss_xx',
              project: 'nmgmtyq-zrzh',
            },
          },
        })
      }
      if (key === 'ydspxj') {
        return Promise.resolve({
          data: {
            allowLoginType: ['tel'],
            prefix: 'zrzh',
            theme: 'common',
            title: '市政基础设施视频智能化感知和巡检系统',
            welcome: '',
            introduction: '市政基础设施视频智能化感知和巡检系统',
            logo: null, // logo
            image: null,
            bgImage: null,
            // 登录相关
            loginTitle: '市政基础设施视频智能化感知和巡检系统',
            loginIntroduction: '市政基础设施视频智能化感知和巡检系统',
            url: {
              navType: 'push',
              url: '/cp/ow-video/apps/975/tbs/525?vid=1443&tpl=ydspxj&token=$token',
              project: 'ow-video',
            },
          },
        })
      }
      if (key === 'rzsb') {
        return Promise.resolve({
          data: {
            allowLoginType: ['tel'],
            prefix: 'common',
            theme: 'common',
            title: '日志上报系统',
            welcome: '',
            introduction: '日志上报系统',
            logo: null, // logo
            image: null,
            bgImage: null,
            // 登录相关
            loginTitle: '日志上报系统',
            loginIntroduction: '日志上报系统',
            url: {
              navType: 'push',
              url: '/apps/976/tbs/638?tpl=rzsb&token=$token&vid=1505',
              project: 'web',
            },
          },
        })
      }
      if (key === 'yldzhtgl') {
        return Promise.resolve({
          data: {
            allowLoginType: ['tel', 'code'],
            prefix: 'common',
            theme: 'common',
            title: '北京市通州区永乐店镇合同管理系统',
            welcome: '',
            introduction: '北京市通州区永乐店镇合同管理系统',
            logo: null, // logo
            image: null,
            bgImage: null,
            // 登录相关
            loginTitle: '北京市通州区永乐店镇合同管理系统',
            loginIntroduction: '北京市通州区永乐店镇合同管理系统',
            url: {
              navType: 'push',
              url: '/cp/tzyldzzf-contract/apps/978/tbs/671?tpl=yldzhtgl&token=$token&vid=1545',
              project: 'web',
            },
          },
        })
      }
      if (key === 'cyhjjc') {
        return Promise.resolve({
          data: {
            allowLoginType: ['tel'],
            prefix: 'common',
            theme: 'common',
            title: '朝阳区环境专项检查平台',
            welcome: '',
            introduction: '朝阳区环境专项检查平台',
            logo: null, // logo
            image: null,
            bgImage: null,
            // 登录相关
            loginTitle: '朝阳区环境专项检查平台',
            loginIntroduction: '朝阳区环境专项检查平台',
            navTitle: '朝阳区环境专项检查平台',
            url: {
              navType: 'push',
              url: '/cp/cy-hjjc/apps/979/tbs/687?tpl=cyhjjc&vid=1553&token=$token',
              project: 'web',
            },
          },
        })
      }
      if (key === 'wbhjjc') {
        return Promise.resolve({
          data: {
            allowLoginType: ['tel'],
            prefix: 'common',
            theme: 'common',
            title: '公司外部环境监测与分析',
            welcome: '',
            introduction: '公司外部环境监测与分析',
            logo: null, // logo
            image: null,
            bgImage: null,
            // 登录相关
            loginTitle: '公司外部环境监测与分析',
            loginIntroduction: '公司外部环境监测与分析',
            navIcon: {
              icon: 'wbhj',
              width: 190,
              height: 38,
            },
          },
        })
      }
      if (key === 'xcfz') {
        return Promise.resolve({
          data: {
            allowLoginType: ['tel'],
            prefix: 'common',
            theme: 'common',
            title: '西城辅助项目',
            welcome: '',
            introduction: '西城辅助项目',
            logo: null, // logo
            image: null,
            bgImage: null,
            // 登录相关
            loginTitle: '西城辅助项目',
            loginIntroduction: '西城辅助项目',
          },
        })
      }
      if (key === 'mggf') {
        return Promise.resolve({
          data: {
            allowLoginType: ['tel'],
            prefix: 'common',
            theme: 'common',
            title: '美国国防采办数据监测分析系统',
            welcome: '',
            introduction: '美国国防采办数据监测分析系统',
            logo: null, // logo
            image: null,
            bgImage: null,
            // 登录相关
            loginTitle: '美国国防采办数据监测分析系统',
            loginIntroduction: '美国国防采办数据监测分析系统',
          },
        })
      }
      if (key === 'ddqljfl') {
        return Promise.resolve({
          data: {
            allowLoginType: ['tel'],
            prefix: 'common',
            theme: 'common',
            title: '大东区垃圾分类全链路智慧化管理平台',
            welcome: '',
            introduction: '大东区垃圾分类全链路智慧化管理平台',
            logo: null, // logo
            image: null,
            bgImage: null,
            // 登录相关
            loginTitle: '大东区垃圾分类全链路智慧化管理平台',
            loginIntroduction: '大东区垃圾分类全链路智慧化管理平台',
            navIcon: {
              icon: 'ddljfl',
              width: 239,
              height: 40,
            },
          },
        })
      }
      if (key === 'mbyxm') {
        return Promise.resolve({
          data: {
            allowLoginType: ['tel'],
            prefix: 'common',
            theme: 'common',
            title: '模版一项目',
            welcome: '',
            introduction: '模版一项目',
            logo: null, // logo
            image: null,
            bgImage: null,
            // 登录相关
            loginTitle: '模版一项目',
            loginIntroduction: '模版一项目',
          },
        })
      }
      if (key === 'mbexm') {
        return Promise.resolve({
          data: {
            allowLoginType: ['tel'],
            prefix: 'common',
            theme: 'common',
            title: '模版二项目',
            welcome: '',
            introduction: '模版二项目',
            logo: null, // logo
            image: null,
            bgImage: null,
            // 登录相关
            loginTitle: '模版二项目',
            loginIntroduction: '模版二项目',
          },
        })
      }
      if (key === 'mbsxm') {
        return Promise.resolve({
          data: {
            allowLoginType: ['tel'],
            prefix: 'common',
            theme: 'common',
            title: '模版三项目',
            welcome: '',
            introduction: '模版三项目',
            logo: null, // logo
            image: null,
            bgImage: null,
            // 登录相关
            loginTitle: '模版三项目',
            loginIntroduction: '模版三项目',
          },
        })
      }
      if (key === 'cthcp') {
        return Promise.resolve({
          data: {
            allowLoginType: ['tel'],
            prefix: 'common',
            theme: 'common',
            title: '密云区2023年文明城区创建检查整改系统',
            welcome: '',
            introduction: '密云区2023年文明城区创建检查整改系统',
            logo: null, // logo
            image: null,
            bgImage: null,
            // 登录相关
            loginTitle: '密云区2023年文明城区创建检查整改系统',
            loginIntroduction: '密云区2023年文明城区创建检查整改系统',
            navTitle: '密云区2023年文明城区创建检查整改系统',
          },
        })
      }
      if (key === 'dsfxcfw') {
        return Promise.resolve({
          data: {
            allowLoginType: ['tel'],
            prefix: 'common',
            theme: 'common',
            title: '2021年疏解整治促提升第三方巡查服务',
            welcome: '',
            introduction: '2021年疏解整治促提升第三方巡查服务',
            logo: null, // logo
            image: null,
            bgImage: null,
            // 登录相关
            loginTitle: '2021年疏解整治促提升第三方巡查服务',
            loginIntroduction: '2021年疏解整治促提升第三方巡查服务',
          },
        })
      }
      if (key === 'zjzsjcpt') {
        return Promise.resolve({
          data: {
            allowLoginType: ['tel'],
            prefix: 'common',
            theme: 'common',
            title: '国际政界指数监测平台',
            welcome: '',
            introduction: '国际政界指数监测平台',
            logo: null, // logo
            image: null,
            bgImage: null,
            // 登录相关
            loginTitle: '国际政界指数监测平台',
            loginIntroduction: '国际政界指数监测平台',
            navTitle: '国际政界指数监测平台',
          },
        })
      }
      if (key === 'wsjdjc') {
        return Promise.resolve({
          data: {
            allowLoginType: ['tel'],
            prefix: 'common',
            theme: 'common',
            title: '北京市行业环境卫生监督检查-农村公厕',
            welcome: '',
            introduction: '北京市行业环境卫生监督检查-农村公厕',
            logo: null, // logo
            image: null,
            bgImage: null,
            // 登录相关
            loginTitle: '北京市行业环境卫生监督检查-农村公厕',
            loginIntroduction: '北京市行业环境卫生监督检查-农村公厕',
          },
        })
      }
      if (key === 'ddmpt') {
        return Promise.resolve({
          data: {
            allowLoginType: ['tel'],
            prefix: 'common',
            theme: 'common',
            title: '低代码平台',
            welcome: '',
            introduction: '低代码平台',
            logo: null, // logo
            image: null,
            bgImage: null,
            // 登录相关
            loginTitle: '低代码平台',
            loginIntroduction: '低代码平台',
          },
        })
      }
      if (key === 'filter') {
        return Promise.resolve({
          data: {
            allowLoginType: ['tel'],
            prefix: 'common',
            theme: 'common',
            title: '通用筛选项项目',
            welcome: '',
            introduction: '通用筛选项项目',
            logo: null, // logo
            image: null,
            bgImage: null,
            // 登录相关
            loginTitle: '通用筛选项项目',
            loginIntroduction: '通用筛选项项目',
          },
        })
      }
      if (key === 'lstl') {
        return Promise.resolve({
          data: {
            allowLoginType: ['tel'],
            prefix: 'common',
            theme: 'common',
            title: '2022年莱绅通灵神访稽核项目',
            welcome: '',
            introduction: '2022年莱绅通灵神访稽核项目',
            logo: null, // logo
            image: null,
            bgImage: null,
            // 登录相关
            loginTitle: '2022年莱绅通灵神访稽核项目',
            loginIntroduction: '2022年莱绅通灵神访稽核项目',
          },
        })
      }
      if (key === 'pgcxhjjs') {
        return Promise.resolve({
          data: {
            allowLoginType: ['tel'],
            prefix: 'common',
            theme: 'common',
            title: '2022年平谷区城乡环境建设咨询服务项目',
            welcome: '',
            introduction: '2022年平谷区城乡环境建设咨询服务项目',
            logo: null, // logo
            image: null,
            bgImage: null,
            // 登录相关
            loginTitle: '2022年平谷区城乡环境建设咨询服务项目',
            loginIntroduction: '2022年平谷区城乡环境建设咨询服务项目',
          },
        })
      }
      if (key === 'qjzhyl') {
        return Promise.resolve({
          data: {
            allowLoginType: ['tel'],
            prefix: 'common',
            theme: 'common',
            title: '曲靖市智慧园林全体系工作管理平台',
            welcome: '',
            introduction: '曲靖市智慧园林全体系工作管理平台',
            logo: null, // logo
            image: null,
            bgImage: null,
            // 登录相关
            loginTitle: '曲靖市智慧园林全体系工作管理平台',
            loginIntroduction: '曲靖市智慧园林全体系工作管理平台',
            navTitle: '曲靖市智慧园林全体系工作管理平台',
            custom_theme: {
              colors: {
                primary: {
                  50: '#E8F8F2',
                  100: '#BCEBDC',
                  200: '#85DBBE',
                  300: '#48C79C',
                  400: '#00A870',
                  500: '#078D5C',
                  600: '#48C79C',
                  700: '#00A870',
                },
              },
            },
          },
        })
      }
      if (key === 'syhjws') {
        return Promise.resolve({
          data: {
            allowLoginType: ['tel'],
            prefix: 'common',
            theme: 'common',
            title: '沈阳市环境卫生监管系统',
            welcome: '',
            introduction: '沈阳市环境卫生监管系统',
            logo: null, // logo
            image: null,
            bgImage: null,
            // 登录相关
            loginTitle: '沈阳市环境卫生监管系统',
            loginIntroduction: '沈阳市环境卫生监管系统',
            navTitle: '沈阳市环境卫生第三方监管系统',
          },
        })
      }
      if (key === 'cypystl') {
        return Promise.resolve({
          data: {
            allowLoginType: ['tel'],
            prefix: 'common',
            theme: 'common',
            title: '朝阳区平原生态林养护管理监督检查平台',
            welcome: '',
            introduction: '朝阳区平原生态林养护管理监督检查平台',
            logo: null, // logo
            image: null,
            bgImage: null,
            // 登录相关
            loginTitle: '朝阳区平原生态林养护管理监督检查平台',
            loginIntroduction: '朝阳区平原生态林养护管理监督检查平台',
            navTitle: '朝阳区平原生态林养护管理监督检查平台',
          },
        })
      }
      if (key === 'cphczjc') {
        return Promise.resolve({
          data: {
            allowLoginType: ['tel'],
            prefix: 'common',
            theme: 'common',
            title: '昌平区河长制检查',
            welcome: '',
            introduction: '昌平区河长制检查',
            logo: null, // logo
            image: null,
            bgImage: null,
            // 登录相关
            loginTitle: '昌平区河长制检查',
            loginIntroduction: '昌平区河长制检查',
          },
        })
      }
      if (key === 'sgwzdbg') {
        return Promise.resolve({
          data: {
            allowLoginType: ['tel'],
            prefix: 'common',
            theme: 'common',
            title: '市管委自动报告',
            welcome: '',
            introduction: '市管委自动报告',
            logo: null, // logo
            image: null,
            bgImage: null,
            // 登录相关
            loginTitle: '市管委自动报告',
            loginIntroduction: '市管委自动报告',
          },
        })
      }
      if (key === 'dlljfl') {
        return Promise.resolve({
          data: {
            allowLoginType: ['tel'],
            prefix: 'common',
            theme: 'common',
            title: '大连市城市生活垃圾分类检查考核智慧管理平台(历史数据)',
            welcome: '',
            introduction:
              '大连市城市生活垃圾分类检查考核智慧管理平台(历史数据)',
            logo: null, // logo
            image: null,
            bgImage: null,
            // 登录相关
            loginTitle: '大连市城市生活垃圾分类检查考核智慧管理平台(历史数据)',
            loginIntroduction:
              '大连市城市生活垃圾分类检查考核智慧管理平台(历史数据)',
          },
        })
      }
      if (key === 'dlljflxzsj') {
        return Promise.resolve({
          data: {
            allowLoginType: ['tel'],
            prefix: 'common',
            theme: 'common',
            title: '大连市城市生活垃圾分类检查考核智慧管理平台',
            welcome: '',
            introduction: '大连市城市生活垃圾分类检查考核智慧管理平台',
            logo: null, // logo
            image: null,
            bgImage: null,
            // 登录相关
            loginTitle: '大连市城市生活垃圾分类检查考核智慧管理平台',
            loginIntroduction: '大连市城市生活垃圾分类检查考核智慧管理平台',
            navTitle: '大连市城市生活垃圾分类检查考核智慧管理平台',
          },
        })
      }
      if (key === 'zjzhgl') {
        return Promise.resolve({
          data: {
            allowLoginType: ['tel'],
            prefix: 'common',
            theme: 'common',
            title: '湛江市创建全国文明城市智慧管理项目',
            welcome: '',
            introduction: '湛江市创建全国文明城市智慧管理项目',
            logo: null, // logo
            image: null,
            bgImage: null,
            // 登录相关
            loginTitle: '湛江市创建全国文明城市智慧管理项目',
            loginIntroduction: '湛江市创建全国文明城市智慧管理项目',
            navIcon: {
              icon: 'zjsdjcIcon',
              width: 152,
              height: 40,
            },
            custom_theme: {
              colors: {
                primary: {
                  50: '#FFDBDF',
                  100: '#FCC3CB',
                  200: '#F9A2AD',
                  300: '#F67A88',
                  400: '#E45868',
                  500: '#D53B4D',
                  600: '#C82A3D',
                  700: '#BD192D',
                  800: '#A41123',
                  900: '#8B0B1A',
                },
              },
              palettes: {
                primary: '189,25,45',
              },
            },
          },
        })
      }
      if (key === 'tyzrzh') {
        return Promise.resolve({
          data: {
            allowLoginType: ['tel'],
            prefix: 'zrzh',
            theme: 'common',
            title: '第一次自然灾害普查县级应用系统',
            welcome: '',
            introduction: '第一次自然灾害普查县级应用系统',
            logo: null, // logo
            image: null,
            bgImage: null,
            // 登录相关
            loginTitle: '第一次自然灾害普查县级应用系统',
            loginIntroduction: '第一次自然灾害普查县级应用系统',
          },
        })
      }
      if (key === 'hrwmcq') {
        return Promise.resolve({
          data: {
            allowLoginType: ['tel'],
            prefix: 'common',
            theme: 'common',
            title: '怀柔区2022年创建全国文明城区项目',
            welcome: '',
            introduction: '怀柔区2022年创建全国文明城区项目',
            logo: null, // logo
            image: null,
            bgImage: null,
            // 登录相关
            loginTitle: '怀柔区2022年创建全国文明城区项目',
            loginIntroduction: '怀柔区2022年创建全国文明城区项目',
          },
        })
      }
      if (key === 'tdqs') {
        return Promise.resolve({
          data: {
            allowLoginType: ['tel'],
            prefix: 'common',
            theme: 'common',
            title: '配电网项目智慧管理模拟仿真平台',
            welcome: '',
            introduction: '配电网项目智慧管理模拟仿真平台',
            logo: null, // logo
            image: null,
            bgImage: null,
            // 登录相关
            loginTitle: '配电网项目智慧管理模拟仿真平台',
            loginIntroduction: '配电网项目智慧管理模拟仿真平台',
          },
        })
      }
      if (key === 'tdqsback') {
        return Promise.resolve({
          data: {
            allowLoginType: ['tel'],
            prefix: 'common',
            theme: 'common',
            title: '配电网项目智慧管理模拟仿真平台',
            welcome: '',
            introduction: '配电网项目智慧管理模拟仿真平台',
            logo: null, // logo
            image: null,
            bgImage: null,
            // 登录相关
            loginTitle: '配电网项目智慧管理模拟仿真平台',
            loginIntroduction: '配电网项目智慧管理模拟仿真平台',
          },
        })
      }
      if (key === 'wmcq') {
        return Promise.resolve({
          data: {
            allowLoginType: ['tel'],
            prefix: 'common',
            theme: 'common',
            title: '西城区文明城区建设自检系统',
            welcome: '',
            introduction: '西城区文明城区建设自检系统',
            logo: null, // logo
            image: null,
            bgImage: null,
            // 登录相关
            loginTitle: '西城区文明城区建设自检系统',
            loginIntroduction: '西城区文明城区建设自检系统',
          },
        })
      }
      if (key === 'rxsq') {
        return Promise.resolve({
          data: {
            allowLoginType: ['tel'],
            prefix: 'common',
            theme: 'common',
            title: '北京市管委热线诉求分析',
            welcome: '',
            introduction: '北京市管委热线诉求分析',
            logo: null, // logo
            image: null,
            bgImage: null,
            // 登录相关
            loginTitle: '北京市管委热线诉求分析',
            loginIntroduction: '北京市管委热线诉求分析',
          },
        })
      }
      if (key === 'zjzhgl-wmsjzx') {
        return Promise.resolve({
          data: {
            allowLoginType: ['tel'],
            prefix: 'common',
            theme: 'common',
            title: '湛江市文明实践中心',
            welcome: '',
            introduction: '湛江市文明实践中心',
            logo: null, // logo
            image: null,
            bgImage: null,
            // 登录相关
            loginTitle: '湛江市文明实践中心',
            loginIntroduction: '湛江市文明实践中心',
            navIcon: {
              icon: 'zjwmsjIcon',
              width: 100,
              height: 40,
              text: '文明实践中心',
            },
            custom_theme: {
              colors: {
                primary: {
                  50: '#FFDBDF',
                  100: '#FCC3CB',
                  200: '#F9A2AD',
                  300: '#F67A88',
                  400: '#E45868',
                  500: '#D53B4D',
                  600: '#C82A3D',
                  700: '#BD192D',
                  800: '#A41123',
                  900: '#8B0B1A',
                },
              },
              palettes: {
                primary: '189,25,45',
              },
            },
          },
        })
      }
      if (key === 'zjzhgl-hrhs') {
        return Promise.resolve({
          data: {
            allowLoginType: ['tel'],
            prefix: 'common',
            theme: 'common',
            title: '湛江市道德模范与好人好事',
            welcome: '',
            introduction: '湛江市道德模范与好人好事',
            logo: null, // logo
            image: null,
            bgImage: null,
            // 登录相关
            loginTitle: '湛江市道德模范与好人好事',
            loginIntroduction: '湛江市道德模范与好人好事',
            navIcon: {
              icon: 'zjddgfysbhrIcon',
              width: 100,
              height: 40,
            },
            custom_theme: {
              colors: {
                primary: {
                  50: '#FFDBDF',
                  100: '#FCC3CB',
                  200: '#F9A2AD',
                  300: '#F67A88',
                  400: '#E45868',
                  500: '#D53B4D',
                  600: '#C82A3D',
                  700: '#BD192D',
                  800: '#A41123',
                  900: '#8B0B1A',
                },
              },
              palettes: {
                primary: '189,25,45',
              },
            },
          },
        })
      }
      if (key === 'zjzhgl-dwgl') {
        return Promise.resolve({
          data: {
            allowLoginType: ['tel'],
            prefix: 'common',
            theme: 'common',
            title: '湛江市单位管理',
            welcome: '',
            introduction: '湛江市单位管理',
            logo: null, // logo
            image: null,
            bgImage: null,
            // 登录相关
            navIcon: {
              icon: 'zjwmdwglIcon',
              width: 100,
              height: 40,
            },
            loginTitle: '湛江市单位管理',
            loginIntroduction: '湛江市单位管理',
            custom_theme: {
              colors: {
                primary: {
                  50: '#FFDBDF',
                  100: '#FCC3CB',
                  200: '#F9A2AD',
                  300: '#F67A88',
                  400: '#E45868',
                  500: '#D53B4D',
                  600: '#C82A3D',
                  700: '#BD192D',
                  800: '#A41123',
                  900: '#8B0B1A',
                },
              },
              palettes: {
                primary: '189,25,45',
              },
            },
          },
        })
      }
      if (key === 'jsjb') {
        return Promise.resolve({
          data: {
            allowLoginType: ['tel'],
            prefix: 'common',
            theme: 'common',
            title: '接诉即办大数据分析服务其他专业技术服务采购项目',
            welcome: '',
            introduction: '接诉即办大数据分析服务其他专业技术服务采购项目',
            logo: null, // logo
            image: null,
            bgImage: null,
            // 登录相关
            loginTitle: '接诉即办大数据分析服务其他专业技术服务采购项目',
            loginIntroduction: '接诉即办大数据分析服务其他专业技术服务采购项目',
            navTitle: '接诉即办大数据分析服务其他专业技术服务采购项目',
          },
        })
      }
      if (key === 'cyzxjc') {
        return Promise.resolve({
          data: {
            allowLoginType: ['tel'],
            prefix: 'common',
            theme: 'common',
            title: '朝阳区环境专项检查平台（二期）',
            welcome: '',
            introduction: '朝阳区环境专项检查平台（二期）',
            logo: null, // logo
            image: null,
            bgImage: null,
            // 登录相关
            loginTitle: '朝阳区环境专项检查平台（二期）',
            loginIntroduction: '朝阳区环境专项检查平台（二期）',
            navTitle: '朝阳区环境专项检查平台（二期）',
          },
        })
      }
      if (key === 'qzewm') {
        return Promise.resolve({
          data: {
            allowLoginType: ['tel'],
            prefix: 'common',
            theme: 'common',
            title: '全总二维码',
            welcome: '',
            introduction: '全总二维码',
            logo: null, // logo
            image: null,
            bgImage: null,
            // 登录相关
            loginTitle: '全总二维码',
            loginIntroduction: '全总二维码',
          },
        })
      }
      if (key === 'ljfl-xq') {
        return Promise.resolve({
          data: {
            allowLoginType: ['tel'],
            prefix: 'common',
            theme: 'common',
            title: '垃圾分类示范片区复验和部分示范片区二次验收服务-小区',
            welcome: '',
            introduction: '垃圾分类示范片区复验和部分示范片区二次验收服务-小区',
            logo: null, // logo
            image: null,
            bgImage: null,
            // 登录相关
            loginTitle: '垃圾分类示范片区复验和部分示范片区二次验收服务-小区',
            loginIntroduction:
              '垃圾分类示范片区复验和部分示范片区二次验收服务-小区',
            navTitle: '垃圾分类示范片区复验和部分示范片区二次验收服务-小区',
          },
        })
      }
      if (key === 'zzpczz') {
        return Promise.resolve({
          data: {
            allowLoginType: ['tel'],
            prefix: 'common',
            theme: 'common',
            title: '郑州市房屋建筑安全隐患排查整治系统',
            welcome: '',
            introduction: '郑州市房屋建筑安全隐患排查整治系统',
            logo: null, // logo
            image: null,
            bgImage: null,
            // 登录相关
            loginTitle: '郑州市房屋建筑安全隐患排查整治系统',
            loginIntroduction: '郑州市房屋建筑安全隐患排查整治系统',
            navTitle: '郑州市房屋建筑安全隐患排查整治系统',
          },
        })
      }
      if (key === 'lzzrzh') {
        return Promise.resolve({
          data: {
            allowLoginType: ['tel'],
            prefix: 'common',
            theme: 'common',
            title: '潞州区应急管理局第一次全国自然灾害综合风险普查项目',
            welcome: '',
            introduction: '潞州区应急管理局第一次全国自然灾害综合风险普查项目',
            logo: null, // logo
            image: null,
            bgImage: null,
            // 登录相关
            loginTitle: '潞州区应急管理局第一次全国自然灾害综合风险普查项目',
            loginIntroduction:
              '潞州区应急管理局第一次全国自然灾害综合风险普查项目',
            navIcon: {
              icon: 'lz',
              width: 520,
              height: 70,
            },
          },
        })
      }
      if (key === 'xcljfl') {
        return Promise.resolve({
          data: {
            allowLoginType: ['tel'],
            prefix: 'common',
            theme: 'common',
            title: '2022年西城区垃圾分类日常检查项目',
            welcome: '',
            introduction: '2022年西城区垃圾分类日常检查项目',
            logo: null, // logo
            image: null,
            bgImage: null,
            // 登录相关
            loginTitle: '2022年西城区垃圾分类日常检查项目',
            loginIntroduction: '2022年西城区垃圾分类日常检查项目',
            navTitle: '2022年西城区垃圾分类日常检查项目',
          },
        })
      }
      if (key === 'jlljfl') {
        return Promise.resolve({
          data: {
            allowLoginType: ['tel'],
            prefix: 'common',
            theme: 'common',
            title: '净绿垃圾分类管理平台',
            welcome: '',
            introduction: '净绿垃圾分类管理平台',
            logo: null, // logo
            image: null,
            bgImage: null,
            // 登录相关
            loginTitle: '净绿垃圾分类管理平台',
            loginIntroduction: '净绿垃圾分类管理平台',
            navTitle: '净绿垃圾分类管理平台',
          },
        })
      }
      if (key === 'sjswmsjzx') {
        return Promise.resolve({
          data: {
            allowLoginType: ['tel'],
            prefix: 'common',
            theme: 'common',
            title: '石景山文明实践中心',
            welcome: '',
            introduction: '石景山文明实践中心',
            logo: null, // logo
            image: null,
            bgImage: null,
            // 登录相关
            loginTitle: '石景山文明实践中心',
            loginIntroduction: '石景山文明实践中心',
            custom_theme: {
              colors: {
                primary: {
                  50: '#FFDBDF',
                  100: '#FCC3CB',
                  200: '#F9A2AD',
                  300: '#F67A88',
                  400: '#E45868',
                  500: '#D53B4D',
                  600: '#C82A3D',
                  700: '#BD192D',
                  800: '#A41123',
                  900: '#8B0B1A',
                },
              },
            },
          },
        })
      }
      if (key === 'gxdw') {
        return Promise.resolve({
          data: {
            allowLoginType: ['tel'],
            prefix: 'common',
            theme: 'common',
            title: '广西电网基于设备风险管控与隐患治理',
            welcome: '',
            introduction: '广西电网基于设备风险管控与隐患治理',
            logo: null, // logo
            image: null,
            bgImage: null,
            // 登录相关
            loginTitle: '广西电网基于设备风险管控与隐患治理',
            loginIntroduction: '广西电网基于设备风险管控与隐患治理',
            navIcon: {
              icon: 'gxdw',
              width: 200,
              height: 28,
            },
            custom_theme: {
              colors: {
                primary: {
                  50: '#EFF3FF',
                  100: '#CFDCFF',
                  200: '#A0B9FF',
                  300: '#90AEFF',
                  400: '#80A2FF',
                  500: '#7096FF',
                  600: '#608BFF',
                  700: '#507FFF',
                  800: '#366CFF',
                  900: '#0E4FFF',
                },
              },
            },
          },
        })
      }
      if (key === 'ljfldemo') {
        return Promise.resolve({
          data: {
            allowLoginType: ['tel'],
            prefix: 'common',
            theme: 'common',
            title: '清研环卫一体化智能管理平台',
            welcome: '',
            introduction: '清研环卫一体化智能管理平台',
            logo: null, // logo
            image: null,
            bgImage: null,
            // 登录相关
            loginTitle: '清研环卫一体化智能管理平台',
            loginIntroduction: '清研环卫一体化智能管理平台',
            navIcon: {
              icon: 'ddljfldemo',
              width: 314,
              height: 40,
            },
          },
        })
      }
      if (key === 'fwzljc') {
        return Promise.resolve({
          data: {
            allowLoginType: ['tel'],
            prefix: 'common',
            theme: 'common',
            title: '2022年服务业服务质量监测评价项目',
            welcome: '',
            introduction: '2022年服务业服务质量监测评价项目',
            logo: null, // logo
            image: null,
            bgImage: null,
            // 登录相关
            loginTitle: '2022年服务业服务质量监测评价项目',
            loginIntroduction: '2022年服务业服务质量监测评价项目',
            navTitle: '2022年服务业服务质量监测评价项目',
          },
        })
      }
      if (key === 'dbys') {
        return Promise.resolve({
          data: {
            allowLoginType: ['tel'],
            prefix: 'common',
            theme: 'common',
            title: '大表演示项目',
            welcome: '',
            introduction: '大表演示项目',
            logo: null, // logo
            image: null,
            bgImage: null,
            // 登录相关
            loginTitle: '大表演示项目',
            loginIntroduction: '大表演示项目',
          },
        })
      }
      if (key === 'xczhxc') {
        return Promise.resolve({
          data: {
            allowLoginType: ['tel'],
            prefix: 'common',
            theme: 'common',
            title: '西城区限额以下工程综合巡查管理系统',
            welcome: '',
            introduction: '西城区限额以下工程综合巡查管理系统',
            logo: null, // logo
            image: null,
            bgImage: null,
            // 登录相关
            loginTitle: '西城区限额以下工程综合巡查管理系统',
            loginIntroduction: '西城区限额以下工程综合巡查管理系统',
            navTitle: '西城区限额以下工程综合巡查管理系统',
          },
        })
      }
      if (key === 'cyzhdd') {
        return Promise.resolve({
          data: {
            allowLoginType: ['tel'],
            prefix: 'common',
            theme: 'common',
            title: '察隅县应急指挥调度平台',
            welcome: '',
            introduction: '察隅县应急指挥调度平台',
            logo: null, // logo
            image: null,
            bgImage: null,
            // 登录相关
            loginTitle: '察隅县应急指挥调度平台',
            loginIntroduction: '察隅县应急指挥调度平台',
          },
        })
      }
      if (key === 'ftstl') {
        return Promise.resolve({
          data: {
            allowLoginType: ['tel'],
            prefix: 'common',
            theme: 'common',
            title: '丰台区生态林管护经营系统',
            welcome: '',
            introduction: '丰台区生态林管护经营系统',
            logo: null, // logo
            image: null,
            bgImage: null,
            // 登录相关
            loginTitle: '丰台区生态林管护经营系统',
            loginIntroduction: '丰台区生态林管护经营系统',
            navTitle: '丰台区生态林管护经营系统',
            navTitleStyle: { wrap: false },
            navIcon: {
              icon: 'ft',
              width: 40,
              height: 40,
            },
          },
        })
      }
      if (key === 'hrjcxs') {
        return Promise.resolve({
          data: {
            allowLoginType: ['tel'],
            prefix: 'common',
            theme: 'common',
            title: '怀柔区河道综合检查巡视项目系统',
            welcome: '',
            introduction: '怀柔区河道综合检查巡视项目系统',
            logo: null, // logo
            image: null,
            bgImage: null,
            // 登录相关
            loginTitle: '怀柔区河道综合检查巡视项目系统',
            loginIntroduction: '怀柔区河道综合检查巡视项目系统',
            navTitle: '怀柔区河道综合检查巡视项目系统',
          },
        })
      }
      if (key === 'xyhcgz') {
        return Promise.resolve({
          data: {
            allowLoginType: ['tel'],
            prefix: 'common',
            theme: 'common',
            title: '襄垣县农村户厕改造验收平台',
            welcome: '',
            introduction: '襄垣县农村户厕改造验收平台',
            logo: null, // logo
            image: null,
            bgImage: null,
            // 登录相关
            loginTitle: '襄垣县农村户厕改造验收平台',
            loginIntroduction: '襄垣县农村户厕改造验收平台',
            navTitle: '襄垣县农村户厕改造验收平台',
          },
        })
      }
      if (key === 'hdhjjs') {
        return Promise.resolve({
          data: {
            allowLoginType: ['tel'],
            prefix: 'common',
            theme: 'common',
            title: '美丽海淀城市环境建设管理考评系统',
            welcome: '',
            introduction: '美丽海淀城市环境建设管理考评系统',
            logo: null, // logo
            image: null,
            bgImage: null,
            // 登录相关
            loginTitle: '美丽海淀城市环境建设管理考评系统',
            loginIntroduction: '美丽海淀城市环境建设管理考评系统',
            navTitle: '美丽海淀城市环境建设管理考评系统',
            navTitleStyle: { wrap: false },
            navIcon: {
              icon: 'hd',
              width: 40,
              height: 40,
            },
          },
        })
      }
      if (key === 'hhht') {
        return Promise.resolve({
          data: {
            allowLoginType: ['tel'],
            prefix: 'common',
            theme: 'common',
            title: '呼和浩特市生活垃圾分类考核系统',
            welcome: '',
            introduction: '呼和浩特市生活垃圾分类考核系统',
            logo: null, // logo
            image: null,
            bgImage: null,
            // 登录相关
            loginTitle: '呼和浩特市生活垃圾分类考核系统',
            loginIntroduction: '呼和浩特市生活垃圾分类考核系统',
            navTitle: '呼和浩特市生活垃圾分类考核系统',
          },
        })
      }
      if (key === 'syljfl') {
        return Promise.resolve({
          data: {
            allowLoginType: ['tel'],
            prefix: 'common',
            theme: 'common',
            title: '沈阳市生活垃圾分类第三方考核系统',
            welcome: '',
            introduction: '沈阳市生活垃圾分类第三方考核系统',
            logo: null, // logo
            image: null,
            bgImage: null,
            // 登录相关
            loginTitle: '沈阳市生活垃圾分类第三方考核系统',
            loginIntroduction: '沈阳市生活垃圾分类第三方考核系统',
            navTitle: '沈阳市生活垃圾分类第三方考核系统',
          },
        })
      }
      if (key === 'syshlj') {
        return Promise.resolve({
          data: {
            allowLoginType: ['tel'],
            prefix: 'common',
            theme: 'common',
            title: '沈阳市农村生活垃圾检查系统',
            welcome: '',
            introduction: '沈阳市农村生活垃圾检查系统',
            logo: null, // logo
            image: null,
            bgImage: null,
            // 登录相关
            loginTitle: '沈阳市农村生活垃圾检查系统',
            loginIntroduction: '沈阳市农村生活垃圾检查系统',
            navTitle: '沈阳市农村生活垃圾检查系统',
            navTitleStyle: { wrap: false },
          },
        })
      }
      if (key === 'sjshcz') {
        return Promise.resolve({
          data: {
            allowLoginType: ['tel'],
            prefix: 'common',
            theme: 'common',
            title: '石景山区河长制检查项目',
            welcome: '',
            introduction: '石景山区河长制检查项目',
            logo: null, // logo
            image: null,
            bgImage: null,
            // 登录相关
            loginTitle: '石景山区河长制检查项目',
            loginIntroduction: '石景山区河长制检查项目',
            navTitle: '石景山区河长制检查项目',
            navTitleStyle: { wrap: false },
          },
        })
      }
      if (key === 'dljgpt') {
        return Promise.resolve({
          data: {
            allowLoginType: ['tel'],
            prefix: 'common',
            theme: 'common',
            title: '大连城管督导员监管平台',
            welcome: '',
            introduction: '大连城管督导员监管平台',
            logo: null, // logo
            image: null,
            bgImage: null,
            // 登录相关
            loginTitle: '大连城管督导员监管平台',
            loginIntroduction: '大连城管督导员监管平台',
            navTitle: '大连城管督导员监管平台',
            navTitleStyle: { wrap: false },
          },
        })
      }
      if (key === 'myhzz') {
        return Promise.resolve({
          data: {
            allowLoginType: ['tel'],
            prefix: 'common',
            theme: 'common',
            title: '密云区水务局河长制项目',
            welcome: '',
            introduction: '密云区水务局河长制项目',
            logo: null, // logo
            image: null,
            bgImage: null,
            // 登录相关
            loginTitle: '密云区水务局河长制项目',
            loginIntroduction: '密云区水务局河长制项目',
            navTitle: '密云区水务局河长制项目',
            navTitleStyle: { wrap: false },
          },
        })
      }
      if (key === 'lk') {
        return Promise.resolve({
          data: {
            allowLoginType: ['tel'],
            prefix: 'common',
            theme: 'common',
            title: '“文明驾车 礼让行人”专项行动——路口测评',
            welcome: '',
            introduction: '“文明驾车 礼让行人”专项行动——路口测评',
            logo: null, // logo
            image: null,
            bgImage: null,
            // 登录相关
            loginTitle: '“文明驾车 礼让行人”专项行动——路口测评',
            loginIntroduction: '“文明驾车 礼让行人”专项行动——路口测评',
            navTitle: '“文明驾车 礼让行人”专项行动——路口测评',
            navTitleStyle: { wrap: false },
          },
        })
      }
      if (key === 'fsqljflrcjc') {
        return Promise.resolve({
          data: {
            allowLoginType: ['tel'],
            prefix: 'common',
            theme: 'common',
            title: '2023年房山区垃圾分类日常检查',
            welcome: '',
            introduction: '2023年房山区垃圾分类日常检查',
            logo: null, // logo
            image: null,
            bgImage: null,
            // 登录相关
            loginTitle: '2023年房山区垃圾分类日常检查',
            loginIntroduction: '2023年房山区垃圾分类日常检查',
            navTitle: '2023年房山区垃圾分类日常检查',
            navTitleStyle: { wrap: false },
          },
        })
      }
      if (key === 'ftcxhjzhjc') {
        return Promise.resolve({
          data: {
            allowLoginType: ['tel'],
            prefix: 'common',
            theme: 'common',
            title: '2023年丰台区城乡环境建设综合检查',
            welcome: '',
            introduction: '2023年丰台区城乡环境建设综合检查',
            logo: null, // logo
            image: null,
            bgImage: null,
            // 登录相关
            loginTitle: '2023年丰台区城乡环境建设综合检查',
            loginIntroduction: '2023年丰台区城乡环境建设综合检查',
            navTitle: '2023年丰台区城乡环境建设综合检查',
            navTitleStyle: { wrap: false },
          },
        })
      }
      return Promise.resolve({
        data: {
          allowLoginType: ['tel', 'code'],
          // 登录页面上可能会展示一下企业相关信息
          prefix: 'common',
          theme: 'common',
          title: '',
          welcome: '',
          introduction: '',
          logo: null, // logo
          image: null,
          bgImage: null,
          // 登录相关
          loginTitle: '登录title',
          loginIntroduction: '登录Introduction',
          // url: '/apps/957/res/95?tbId=251',
          url: {
            navType: 'push',
            url: '/apps/957/tbs/251?token=$token',
            project: 'web',
          },
        },
      })
    },
  })
  return {
    customInfo: data ? data.data : {},
    mutate,
    isLoading: !error && !data,
    isError: error,
  }
}

// 获取验证码
const fetchLoginCode = (username, codeType) => {
  return http()
    .get(`${getApiVersionDygc()}/customer/code`, {
      searchParams: {
        username,
        codeType,
      },
    })
    .json()
}

// 验证码登录
const loginByCode = (username, code) => {
  return http()
    .get(`${getApiVersionDygc()}/customer/getTokenByUserNameAndCode`, {
      searchParams: {
        username,
        code,
      },
      throwHttpErrors: false,
      parseJson: (res) => {
        return res
      },
    })
    .json()
}

// 调研工厂-用户名\密码登录
const loginByLoginNameDygc = (loginName, password) => {
  return http()
    .get(`${getApiVersionDygc()}/customer/getTokenByLoginName`, {
      searchParams: {
        loginName,
        password,
      },
      throwHttpErrors: false,
      parseJson: (res) => {
        return res
      },
    })
    .json()
}

// 调研工厂-手机号\密码登录
const loginByTelDygc = (username, password) => {
  return http()
    .get(`${getApiVersionDygc()}/customer/token`, {
      searchParams: {
        username,
        password,
      },
      throwHttpErrors: false,
      parseJson: (res) => {
        return res
      },
    })
    .json()
}

// 子账号登录
// const loginByLoginNameToken = (loginName, password) => {
//   return http()
//     .get(`personnelManagement/loginNameToken`, {
//       searchParams: {
//         loginName,
//         password,
//       },
//       throwHttpErrors: false,
//       parseJson: (res) => {
//         return res
//       },
//     })
//     .json()
// }

// 判断用户名是否存在
const checkUserIsExist = (username) => {
  return http()
    .get(`${getApiVersionDygc()}/customer/checkExist`, {
      searchParams: { username },
    })
    .json()
}

// 注册
const userRegister = (data) => {
  return http().post(`${getApiVersionDygc()}/customer/regist`, data).json()
}

// normal相关登录接口

// 获取登录后跳转的地址以及定制信息
const getInformationStorage = (appId, tpl) => {
  return http()
    .get(`${getApiVersion()}/apps/${appId}/informationStorage/my`, {
      searchParams: {
        purpose: 'redirect',
        tpl,
      },
      throwHttpErrors: true,
    })
    .json()
}

// normal-手机号\密码登录
const loginByTel = (mobile, password) => {
  return http()
    .get(`${getApiVersion()}/personnelManagement/mobileToken`, {
      searchParams: {
        mobile,
        password,
      },
      throwHttpErrors: false,
      parseJson: (res) => {
        return res
      },
    })
    .json()
}

// normal-用户名\密码登录
const loginByLoginName = (loginName, password, isCheck = false) => {
  return http()
    .get(`${getApiVersion()}/personnelManagement/loginNameToken`, {
      searchParams: {
        loginName,
        password,
        isCheck,
      },
      throwHttpErrors: false,
      parseJson: (res) => {
        return res
      },
    })
    .json()
}

// 退出登录
const logoutByToken = async () => {
  return http()
    .get(`${getApiVersion()}/personnelManagement/logoutByToken`)
    .json()
}

// 钉钉登录
const loginByDD = (code, source) => {
  return http()
    .get(
      `${getApiVersion()}/personnelManagement/ddSwapToken?code=${code}&source=${source}`,
      {
        throwHttpErrors: false,
        parseJson: (res) => {
          return res
        },
      }
    )
    .json()
}

export {
  useCustomInfoSWR,
  fetchLoginCode,
  loginByCode,
  loginByLoginNameDygc, // 调研工作-用户名\密码登录
  loginByTelDygc, // 调研工厂-手机号\密码登录
  loginByTel, // normal-手机号\密码登录
  loginByLoginName, // normal-用户名\密码登录
  userRegister,
  checkUserIsExist,
  getInformationStorage,
  logoutByToken,
  loginByDD,
}
